// extracted by mini-css-extract-plugin
export default {"section":"styles_section__pij+k","section__title":"styles_section__title__fCEMa","section__head":"styles_section__head__6JWw8"};